import styled, { useTheme } from 'styled-components'
import Modal from '@/components/common/modals/Modal'
import { Typo, TypoVariant } from '@/components/common/typography'

interface CartErrorModalProps {
  onConfirm: (deleteTargetId: number) => void
  onClose: () => void
  isShow: boolean
  deleteTargetId: number | null
}
export const CartItemDeleteModal = ({ onConfirm, isShow, onClose, deleteTargetId }: CartErrorModalProps) => {
  const { color } = useTheme()

  const handleCloseCancel = () => {
    onClose()
  }

  const handleConfirm = () => {
    if (!deleteTargetId) {
      return
    }
    onConfirm(deleteTargetId)
    onClose()
  }

  if (!deleteTargetId) {
    return null
  }

  return (
    <Modal open={isShow}>
      <Modal.Content>
        <Modal.Title>
          <Typo variant={TypoVariant.Heading6Bold}>해당 상품을 삭제하시겠습니까?</Typo>
        </Modal.Title>
      </Modal.Content>
      <Modal.Footer>
        <ModalButtonContainer>
          <ModalButton className="cancel" onClick={handleCloseCancel} color={color.gray900}>
            <Typo variant={TypoVariant.Body1Medium}>취소</Typo>
          </ModalButton>
          <ModalButton className="ok" onClick={handleConfirm}>
            <Typo variant={TypoVariant.Body1Bold} color={color.grayWhite}>
              삭제
            </Typo>
          </ModalButton>
        </ModalButtonContainer>
      </Modal.Footer>
    </Modal>
  )
}

const ModalButtonContainer = styled.div`
  display: flex;
  gap: 0.4rem;
`

const ModalButton = styled.button`
  flex: 1;
  border-radius: 0.8rem;
  border: 0.1rem solid;
  padding: 1.3rem 1.6rem;
  cursor: pointer;
  width: 100%;

  &.ok {
    border-color: ${({ theme }) => theme.color.blue500};
    background-color: ${({ theme }) => theme.color.blue500};
  }

  &.cancel {
    border-color: ${({ theme }) => theme.color.gray200};
    background-color: ${({ theme }) => theme.color.grayWhite};
  }
`
